import React from 'react';
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core';
import styles from '../styles';
import AddIcon from '@material-ui/icons/Add';
import { useTranslation } from 'react-i18next';
import ITranslation from '../../../types/ITranslation';
import TranslationRow from './TranslationRow';
import { KeyedElement } from '../../AttributesDialog/hooks/useCollection';

interface ITranslationsTable {
  elements: KeyedElement<ITranslation>[];
  editTranslation: (props: {
    index: number;
    field: string;
    value: any;
    regex?: any;
    sizelimit?: number;
  }) => void;
  addNewTranslation: () => void;
  removeTranslation: (index: number) => void;
  canAddNewTranslation: (enums: ITranslation[]) => boolean;
  disabled?: boolean;
}

const TranslationsTable = ({
  elements,
  editTranslation,
  addNewTranslation,
  removeTranslation,
  canAddNewTranslation,
  disabled,
}: ITranslationsTable) => {
  const classes = styles();

  const { t } = useTranslation();

  return (
    <TableContainer>
      <Table stickyHeader size="small" padding="none">
        <TableHead>
          <TableRow>
            <TableCell className={classes.tableHeaderCell}>
              Language Code
            </TableCell>
            <TableCell className={classes.tableHeaderCell}>
              Text
              <Typography
                variant="caption"
                component="span"
                className={classes.tableHeaderCaption}
              >
                Max 30 characters
              </Typography>
            </TableCell>
            <TableCell className={classes.tableHeaderCell} align="right">
              {!disabled && (
                <Button
                  variant="outlined"
                  size="small"
                  onClick={() => {
                    if (
                      elements.length >= 1 &&
                      !elements[elements.length - 1].language.code
                    ) {
                      return;
                    }
                    addNewTranslation();
                  }}
                  disabled={!canAddNewTranslation(elements)}
                  startIcon={<AddIcon />}
                  className={classes.buttonStyle}
                >
                  {t('attributes.button.add')}
                </Button>
              )}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {elements.map((element, index) => {
            return (
              <TranslationRow
                elements={elements}
                disabled={disabled}
                editTranslation={editTranslation}
                element={element}
                index={index}
                key={element.key.toString()}
                removeTranslation={removeTranslation}
              />
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TranslationsTable;
